export const textVariants = ['paragraph', 'text', 'label'] as const
export type TextVariant = (typeof textVariants)[number]

export const paragraphSizes = ['lg', 'md', 'sm', 'xs'] as const
export type ParagraphSize = (typeof paragraphSizes)[number]

export const textSizes = ['md', 'sm', 'xs', '2xs', '3xs'] as const
export type TextSize = (typeof textSizes)[number]

export const labelSizes = ['sm', 'xs'] as const
export type LabelSize = (typeof labelSizes)[number]

export type TextAs = 'p' | 'span' | 'label' | 'div' | 'em' | 'strong'

export type TextArgs = {
  variant?: TextVariant
  size?: ParagraphSize | TextSize | LabelSize
  italic?: boolean
  as?: TextAs
}
